module.exports = "/assets/landing-rc/cooperation/img@2x.jpg?qHsmXXT";